import { Input } from '@iwoca/orion';
import { useLingui } from '@lingui/react/macro';
import { useFormContext } from 'react-hook-form';

import styles from './HomeAddressScreen.module.css';
import { homeAddressSchema } from './HomeAddressScreen.schema';
import { TMobileSignupForm } from '../../form/form';
import { useScreenValidation } from '../../form/validation/useScreenValidation';
import { StepLayout } from '../../StepLayout/StepLayout';

// DIT-689. Registration address — street / house number / postcode / town.
// Reads/writes the shared mobile signup form store (DIT-664). Matches the
// desktop AddressField fields + placeholders; the desktop street tooltip copy
// is promoted to the sub-heading here.
export const HomeAddressScreen = () => {
  const { t } = useLingui();
  const {
    register,
    formState: { errors },
  } = useFormContext<TMobileSignupForm>();
  const { validateAndContinue } = useScreenValidation(homeAddressSchema);

  return (
    <StepLayout
      stageTitle={t`Tell us about yourself`}
      heading={t`Your registration address`}
      subHeading={t`We need your current registration address as it appears on your ID.`}
      onContinue={validateAndContinue}
    >
      <div className={styles.fields}>
        <Input
          {...register('homeStreet')}
          label={t`Street`}
          placeholder={t`e.g. Street`}
          className="fs-mask"
          error={errors.homeStreet?.message}
        />
        <div className={styles.row}>
          <Input
            {...register('homeHouseNumber')}
            label={t`House number`}
            placeholder={t`e.g. 21`}
            inputMode="numeric"
            className="fs-mask"
            error={errors.homeHouseNumber?.message}
          />
          <Input
            {...register('homePostcode')}
            label={t`Postcode`}
            placeholder={t`e.g. 37269`}
            inputMode="numeric"
            maxLength={5}
            className="fs-mask"
            error={errors.homePostcode?.message}
          />
        </div>
        <Input
          {...register('homeTown')}
          label={t`Town`}
          placeholder={t`e.g. London`}
          className="fs-mask"
          error={errors.homeTown?.message}
        />
      </div>
    </StepLayout>
  );
};
